import { render, staticRenderFns } from "./DataProcessIcon.vue?vue&type=template&id=2bf03014&scoped=true&"
import script from "./DataProcessIcon.vue?vue&type=script&lang=js&"
export * from "./DataProcessIcon.vue?vue&type=script&lang=js&"
import style0 from "./DataProcessIcon.vue?vue&type=style&index=0&id=2bf03014&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf03014",
  null
  
)

export default component.exports